import React from 'react'
import { LinearProgress } from '@atd/rui-base.mui.linear-progress'

const ProductLoader = () => (
    <div style={{paddingTop: '40px'}}>
        <LinearProgress sx={{'& .MuiLinearProgress-bar': {backgroundColor: 'var(--primary)'}}} />
    </div>
)

export default ProductLoader
